import axios from 'axios';

// Create an axios instance with default config
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
    }
});

// Add request interceptor to manually set CSRF token
api.interceptors.request.use(config => {
    // Get the CSRF token from cookie
    const match = document.cookie.match(/csrftoken=([^;]+)/);
    const csrfToken = match ? match[1] : '';

    // Add token to headers if found
    if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }

    return config;
});

// Response error interceptor (keep existing)
api.interceptors.response.use(
    response => response,
    error => {
        console.error('[API Error]:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);

// Initialize CSRF protection
const initializeCsrf = async () => {
    try {
        await api.get('/get-csrf-token/');
        console.log('CSRF token initialized');
    } catch (error) {
        console.error('Failed to initialize CSRF token:', error);
    }
};

// Initialize CSRF token when this module loads
initializeCsrf();

export default api;
